// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input[data-v-5369ad0e]{background-color:#fff;border-radius:10px}label.q-field[data-v-5369ad0e]{width:332px!important;margin-left:15px}@media (max-width:640px){[data-v-5369ad0e] label.q-field{width:232px!important}}.Imagen[data-v-5369ad0e]{height:50px;width:50px;float:left;margin-right:12px;margin-left:8px;background-color:#fff}", ""]);
// Exports
module.exports = exports;
